var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'banner-grid': true,
    'banner-grid--grid-3': _vm.grid === 3
  }},_vm._l((_vm.banners),function(banner){return _c('div',{key:banner,staticClass:"banner-grid__item-wrapper",on:{"click":function($event){return _vm.onItemClick(banner)}}},[_c('img',{staticClass:"banner-grid__item",attrs:{"src":require(("@/assets/" + _vm.path + "/" + banner + ".jpg"))}}),_vm._t(("item-" + banner),null,{"active":banner === _vm.selectedItem})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }